/**
 * CISC Jobs - Job Search Functionality
 * Bootstrap 5 compatible (no jQuery)
 */

(function() {
    'use strict';

    // Map variables
    let schoolMap;
    let lat = '51.51383';
    let lon = '-0.09846';

    // DOM Ready
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }

    function init() {
        console.log('CISC Jobs initialized');
        
        // Initialize Bootstrap components
        initializeTooltips();
        initializePopovers();
        
        // Initialize Pressburst Jobs functionality
        PressburstJobs.init();
    }

    /**
     * Initialize Bootstrap tooltips
     */
    function initializeTooltips() {
        const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
        [...tooltipTriggerList].map(tooltipTriggerEl => 
            new bootstrap.Tooltip(tooltipTriggerEl)
        );
    }

    /**
     * Initialize Bootstrap popovers
     */
    function initializePopovers() {
        const popoverTriggerList = document.querySelectorAll('[data-bs-toggle="popover"]');
        [...popoverTriggerList].map(popoverTriggerEl => 
            new bootstrap.Popover(popoverTriggerEl)
        );
    }

    /**
     * Main PressburstJobs object
     */
    const PressburstJobs = {
        
        init: function() {
            this.generalJobs();
        },

        initJobSearch: function() {
            this.handleJobSearch();
        },

        initJobDetail: function() {
            this.buildSchoolDetailMap();
            this.handleShareMenu();
        },

        /**
         * General job functionality
         */
        generalJobs: function() {
            const showPopupElements = document.querySelectorAll('.showpopup');
            showPopupElements.forEach(element => {
                element.addEventListener('click', (ev) => {
                    ev.preventDefault();
                    // Assuming TomloprodModal is still available
                    if (typeof TomloprodModal !== 'undefined') {
                        TomloprodModal.openModal('pbinfo');
                    }
                });
            });
        },

        /**
         * Handle job search form and filters
         */
        handleJobSearch: function() {
            const searchForm = document.getElementById('searchfrm');
            if (!searchForm) return;

            const locSelect = document.getElementById('location');
            const catSelect = document.getElementById('category');
            const typeSelect = document.getElementById('type');

            // Handle form submission
            searchForm.addEventListener('submit', (ev) => {
                ev.preventDefault();

                let sterm = document.getElementById('jobsterm')?.value || '';
                let location = locSelect?.value || '';
                let category = catSelect?.value || '';
                let jobtype = typeSelect?.value || '';

                // Check if all filters are empty - redirect to homepage
                if (!sterm && !location && !category && !jobtype) {
                    window.location.href = '/';
                    return false;
                }

                // Use "any" for empty values
                sterm = sterm || 'any';
                location = location || 'any';
                category = category || 'any';
                jobtype = jobtype || 'any';

                // Clean up search term for URL
                if (sterm && sterm !== 'any') {
                    sterm = sterm.replace(/[^a-zA-Z0-9-_\s]/g, '-').replace(/\s+/g, '-');
                }

                // URL encode the values
                sterm = encodeURIComponent(sterm);
                location = encodeURIComponent(location);
                category = encodeURIComponent(category);
                jobtype = encodeURIComponent(jobtype);

                const newUrl = `/search/${sterm}/${location}/${category}/${jobtype}`;
                window.location.href = newUrl;

                return false;
            });

            // Handle dropdown changes to trigger form submission
            if (locSelect) {
                locSelect.addEventListener('change', () => {
                    searchForm.dispatchEvent(new Event('submit', { cancelable: true }));
                });
            }

            if (catSelect) {
                catSelect.addEventListener('change', () => {
                    searchForm.dispatchEvent(new Event('submit', { cancelable: true }));
                });
            }

            if (typeSelect) {
                typeSelect.addEventListener('change', () => {
                    searchForm.dispatchEvent(new Event('submit', { cancelable: true }));
                });
            }

            // Toggle chevron direction when collapsing/expanding
            const advancedFilters = document.getElementById('advancedFilters');
            if (advancedFilters) {
                advancedFilters.addEventListener('show.bs.collapse', () => {
                    const chevron = document.getElementById('filter-chevron');
                    if (chevron) {
                        chevron.classList.remove('fa-chevron-down');
                        chevron.classList.add('fa-chevron-up');
                    }
                });

                advancedFilters.addEventListener('hide.bs.collapse', () => {
                    const chevron = document.getElementById('filter-chevron');
                    if (chevron) {
                        chevron.classList.remove('fa-chevron-up');
                        chevron.classList.add('fa-chevron-down');
                    }
                });
            }

            // Format closing dates with native Intl.DateTimeFormat
            this.formatClosingDates();
        },

        /**
         * Format closing dates using native Intl.DateTimeFormat
         */
        formatClosingDates: function() {
            const closingDates = document.querySelectorAll('.closing[data-isodate]');
            
            if (closingDates.length === 0) return;

            // Create date formatter for UK format (1st January 2025)
            const dateFormatter = new Intl.DateTimeFormat('en-GB', {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
            });

            closingDates.forEach(element => {
                try {
                    const isodate = element.dataset.isodate;
                    const date = new Date(isodate);
                    
                    // Check if date is valid
                    if (isNaN(date.getTime())) {
                        console.warn('Invalid date:', isodate);
                        return;
                    }

                    // Format: "1st January 2025"
                    const day = date.getDate();
                    const suffix = this.getOrdinalSuffix(day);
                    const monthYear = dateFormatter.format(date).split(' ').slice(1).join(' ');
                    
                    const formattedDate = `${day}${suffix} ${monthYear}`;
                    element.innerHTML = `Closing: ${formattedDate}`;
                } catch (error) {
                    console.error('Error formatting date:', error);
                }
            });
        },

        /**
         * Get ordinal suffix for day (1st, 2nd, 3rd, 4th, etc.)
         */
        getOrdinalSuffix: function(day) {
            if (day > 3 && day < 21) return 'th';
            switch (day % 10) {
                case 1: return 'st';
                case 2: return 'nd';
                case 3: return 'rd';
                default: return 'th';
            }
        },

        /**
         * Initialize school detail map with Leaflet
         */
        handleSchoolDetailMap: function(lat, lon) {
            if (lat === undefined) lat = 51.51383;
            if (lon === undefined) lon = -0.09846;
            
            // Check if Leaflet is loaded
            if (typeof L === 'undefined') {
                console.warn('Leaflet (L) is not loaded. Map cannot be initialized.');
                return;
            }

            // Check if map element exists
            const mapElement = document.getElementById('schoolmap');
            if (!mapElement) {
                console.warn('Map element #schoolmap not found');
                return;
            }

            // Check if map was already initialized
            if (mapElement.dataset.mapInitialized === 'true') {
                return;
            }
            
            // Remove existing map if present
            if (schoolMap) {
                schoolMap.off();
                schoolMap.remove();
                schoolMap = null;
            }
            
            try {
                schoolMap = L.map('schoolmap', {
                    center: [lat, lon],
                    zoom: 15
                });
                
                // Updated tile layer with HTTPS
                L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
                    attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
                    maxZoom: 19
                }).addTo(schoolMap);
                
                // Add marker for the school location
                L.marker([lat, lon]).addTo(schoolMap);

                // Mark as initialized
                mapElement.dataset.mapInitialized = 'true';
            } catch (error) {
                console.error('Error initializing Leaflet map:', error);
            }
        },

        /**
         * Build school detail map from data attributes
         */
        buildSchoolDetailMap: function() {
            const mapCanvas = document.querySelector('.small_map_canvas');
            if (!mapCanvas) return;

            const mapLat = mapCanvas.dataset.lat;
            const mapLon = mapCanvas.dataset.lon;

            // Only initialize if we have valid coordinates
            if (mapLat && mapLon && mapLat !== '0' && mapLon !== '0') {
                this.handleSchoolDetailMap(parseFloat(mapLat), parseFloat(mapLon));
            }
        },

        /**
         * Handle share menu functionality
         */
        handleShareMenu: function() {
            // Share menu toggle function
            window.toggleShareMenu = function(button) {
                const menu = button.nextElementSibling;
                const isVisible = menu.style.display !== 'none';

                // Hide all other share menus
                document.querySelectorAll('.share-menu').forEach(m => {
                    m.style.display = 'none';
                });

                // Toggle this menu
                menu.style.display = isVisible ? 'none' : 'block';
            };

            // Close when clicking outside
            document.addEventListener('click', function(event) {
                if (!event.target.closest('.share-container')) {
                    document.querySelectorAll('.share-menu').forEach(menu => {
                        menu.style.display = 'none';
                    });
                }
            });
        }
    };

    // Make PressburstJobs available globally
    window.PressburstJobs = PressburstJobs;

    /**
     * Escape HTML to prevent XSS
     */
    function escapeHtml(text) {
        const map = {
            '&': '&amp;',
            '<': '&lt;',
            '>': '&gt;',
            '"': '&quot;',
            "'": '&#039;'
        };
        return text.replace(/[&<>"']/g, m => map[m]);
    }

})();